import * as actionTypes from "@/store/actions/actionTypes";
import {
  SetPatientActionI,
  SetSettingsActionI,
  SetUserActionI,
  SetWeixinOauthActionI,
} from "@/store/actions";
import dayjs from "dayjs";
import { SettingsI, WeixinOauthI, UserI, PatientI } from "@/types/system";

const initialSettings: SettingsI = {
  collapsedMenu: true,
  allowUpload: false,
  network: "LAN",
};

export const settingsReducer = (
  state = initialSettings,
  action: SetSettingsActionI
) => {
  switch (action.type) {
    case actionTypes.SET_SETTINGS: {
      return Object.assign({}, state, action.payload);
    }
    default:
      return state;
  }
};

const initialWeixinOauth: WeixinOauthI = {
  id: "",
  provider: "",
  openid: "",
  nickname: "",
  sex: 0,
  province: "",
  city: "",
  country: "",
  headimgurl: "",
  privileges: "",
  unionid: "",
  deleteFlag: false,
  sign: "",
  userId: "",
};

export const weixinOauthReducer = (
  state = initialWeixinOauth,
  action: SetWeixinOauthActionI
) => {
  switch (action.type) {
    case actionTypes.SET_WEIXIN_OAUTH: {
      return Object.assign({}, state, action.payload);
    }
    default:
      return state;
  }
};

const initialUser: UserI = {
  id: "",
  token: "",
  username: "",
  cellphone: "",
  email: "",
  nickname: "",
  lastName: "",
  firstName: "",
  fullName: "",
  birthday: dayjs(),
  password: "",
  gender: 0,
  score: 0,
  avatarURL: "",
  lastLoginAt: dayjs(),
  isActive: false,
  isSuperuser: false,
  currentRole: null,
  roleIds: [],
  currentPatient: null,
  patients: [],
  currentEmployee: null,
  employees: [],
  domainId: "",
  domain: null,
};

export const userReducer = (state = initialUser, action: SetUserActionI) => {
  switch (action.type) {
    case actionTypes.SET_USER: {
      console.log(action.payload);
      return Object.assign({}, state, action.payload);
    }
    default:
      return state;
  }
};

const initialPatient: PatientI = {
  id: "",
  name: "",
  pinyin: "",
  py: "",
  identification: "",
  firstAdmission: null,
  dischargeTime: null,
  admissionNumber: "",
  patientId: "",
  telephoneNumber: "",
  nativePlace: "",
  gender: null,
  birthday: null,
  lastVisitDate: null,
  contactStatus: "",
  comment: "",
  histories: [],
  labExams: [],
  followUps: [],
  uploadedFiles: [],
};

export const patientReducer = (
  state = initialPatient,
  action: SetPatientActionI
) => {
  switch (action.type) {
    case actionTypes.SET_PATIENT: {
      return Object.assign({}, state, action.payload);
    }
    default:
      return state;
  }
};
